import React, { useState, useEffect } from 'react';
import './App.css'; // Importing the CSS file for styling
import * as Handy from '@ohdoki/handy-sdk'; // Import the Handy SDK

function MediaLoop() {
  const [images, setImages] = useState([]);
  const [currentImage, setCurrentImage] = useState('');
  const [connectionKey, setConnectionKey] = useState('Enter Connection Key'); // Moved to default or provide through props/environment
  const predefinedBPMs = [
    30, 35, 40, 45, 50, 55, 60, 65,
    70, 75, 80, 85, 90
  ];
  const [bpm, setBpm] = useState(predefinedBPMs[Math.floor(Math.random() * predefinedBPMs.length)]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [handy, setHandy] = useState(null);
  const [isConnected, setIsConnected] = useState(false); // State to track connection status

  function handleFilesUpload(event) {
    const files = Array.from(event.target.files).map(file => URL.createObjectURL(file));
    setImages(prevImages => [...prevImages, ...files]);
  }

  function convertBpmToVelocity(bpm) {
    const minBPM = 30;
    const maxBPM = 90;
    const minVelocity = 5;
    const maxVelocity = 30;
    return Math.round(((bpm - minBPM) / (maxBPM - minBPM)) * (maxVelocity - minVelocity) + minVelocity);
  }

  useEffect(() => {
    async function initHandy() {
      const newHandy = Handy.init();
      try {
        await newHandy.connect(connectionKey);
        setHandy(newHandy);
        console.log('Handy connected!');
        await newHandy.setMode(0); // Ensure mode is set right after connection
        setIsConnected(true);
        console.log('HAMP mode set successfully.');
      } catch (error) {
        console.error('Failed to initialize or connect Handy:', error);
      }
    }

    if (connectionKey) {
      initHandy();
    }

    return () => {
      handy?.disconnect();
      console.log('Disconnecting Handy...');
    };
  }, [connectionKey]);

  useEffect(() => {
    let interval;
  
    if (isPlaying && handy && images.length > 0) {
      interval = setInterval(async () => {
        try {
          const randomIndex = Math.floor(Math.random() * images.length);
          const randomBPM = predefinedBPMs[Math.floor(Math.random() * predefinedBPMs.length)];
          setCurrentImage(images[randomIndex]);
          setBpm(randomBPM);
          await handy.hampPlay();
          const velocity = convertBpmToVelocity(randomBPM);
          await handy.setHampVelocity(velocity);
          console.log(`HAMP play and velocity set for BPM: ${randomBPM}`);
        } catch (error) {
          console.error("Failed to play HAMP or set velocity:", error);
        }
      }, 10000);
    } else if (!isPlaying && handy) {
      handy.hampStop().then(() => {
        console.log("HAMP stopped successfully.");
      }).catch(error => {
        console.error("Failed to stop HAMP mode:", error);
      });
    }
  
    return () => {
      clearInterval(interval);
    };
  }, [isPlaying, handy, images, predefinedBPMs]);
  

  useEffect(() => {
    if (images.length > 0) {
      setCurrentImage(images[0]);
    }
  }, [images]);

  useEffect(() => {
    let intervalId;
    if (isPlaying) {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const tick = () => {
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        gainNode.gain.value = 0.5;
        oscillator.frequency.value = 396;
        oscillator.type = 'triangle';
        oscillator.start();
        setTimeout(() => {
          oscillator.stop();
        }, 100);
      };

      const intervalTime = 60000 / bpm;
      intervalId = setInterval(tick, intervalTime);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isPlaying, bpm]);

  return (
    <div className="media-loop">
      <div className="connection-input-wrapper">
      <div class="file-input-wrapper">
        <input type="file" id="file-input" multiple onChange={handleFilesUpload} accept="image/*" />
        <label htmlFor="file-input">Choose files</label>
      </div>
      
  
  <span className={`connection-status-icon ${isConnected ? 'connected' : 'disconnected'}`}>
    {isConnected ? '✅' : '❌'}
  </span>
</div>
<input
    type="text"
    className="connection-key-input"
    value={connectionKey}
    onChange={(e) => setConnectionKey(e.target.value)}
    placeholder="Enter Handy Connection Key"
  />


      <div className="image-container">
        <img src={currentImage} alt="Displayed Image" />
      </div>
      <div className="controls">
        <button onClick={() => setIsPlaying(!isPlaying)}>
          {isPlaying ? 'Stop Metronome' : 'Start Metronome'}
        </button>
        <div>
          BPM: <input type="number" value={bpm} onChange={e => setBpm(e.target.value)} />
        </div>
      </div>
    </div>
  );
}

export default MediaLoop;
